const apiNames = {
  USER: 'user',//ui
};

const apiOperatonIds = {
  USER_INFO: 'userInfo',//ui
};

export {apiNames, apiOperatonIds};
